// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const geyser = defineModel({
  id: "geyser",
  batchId: "future",
  name: "Geyser",
  tags: ["scenery","geyser","low-poly","age-of-mcp","future","water"],
  summary: "An erupting hot spring — a geothermal landmark.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.3, 0.38, 0.08, 9), color: "#c2bcaa", position: [0, 0.04, 0] },
      { geometry: new THREE.CylinderGeometry(0.22, 0.3, 0.07, 9), color: "#d8d2c4", position: [0, 0.11, 0] },
      { geometry: new THREE.CylinderGeometry(0.15, 0.22, 0.06, 9), color: "#e8e2d4", position: [0, 0.17, 0] },
      { geometry: new THREE.CylinderGeometry(0.08, 0.1, 0.05, 8), color: "#3a3630", position: [0, 0.2, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#c2bcaa", position: [0.215913, 0.077514, 0.091286], scale: [1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#d8d2c4", position: [-0.023904, 0.073432, 0.277787], scale: [1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#c2bcaa", position: [-0.238197, 0.085154, 0.05535], scale: [1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#d8d2c4", position: [-0.149084, 0.072712, -0.247317], scale: [1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.035, 0), color: "#c2bcaa", position: [0.138897, 0.093651, -0.160244], scale: [1, 0.6, 1] },
      { geometry: new THREE.CylinderGeometry(0.04, 0.07, 0.18, 6), color: "#cfe6ee", position: [0, 0.31, 0] },
      { geometry: new THREE.ConeGeometry(0.05, 0.12, 6), color: "#cfe6ee", position: [0, 0.44, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#cfe6ee", position: [0, 0.36, 0], rotation: [0, 0.273921, 0], scale: [1.1, 0.9, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#f2f6f7", position: [0.05, 0.44, 0.02], rotation: [0, 3.624551, 0], scale: [1.1, 0.9, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#cfe6ee", position: [-0.04, 0.5, -0.03], rotation: [0, 0.439171, 0], scale: [1.1, 0.9, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#f2f6f7", position: [0.06, 0.56, 0], rotation: [0, 2.530028, 0], scale: [1.1, 0.9, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#cfe6ee", position: [-0.03, 0.62, 0.04], rotation: [0, 0.892792, 0], scale: [1.1, 0.9, 1.1] },
    ],
  animations: [],
});
